class Modal
{
  constructor()
  {
    // this.container = undefined;

    window.modal = this;
  }

  start()
  {
    // this.container = document.querySelector('.modal');

    // this.title = document.querySelector('.modal__title');
    // this.body = document.querySelector('.modal__body');
  }

  show({ title, body })
  {
    document.querySelector('.modal__title').textContent = title;
    document.querySelector('.modal__body').innerHTML = body;
    document.querySelector('.modal').classList.remove('hidden');
  }

  hide()
  {
    document.querySelector('.modal').classList.add('hidden');
  }
}

export default new Modal();
